module.exports = __webpack_public_path__ + "static/media/council_tax.50ffc63c.png";